export default function getBtnElementId(target: HTMLElement): string | null {
    const tag = target?.tagName;
    if (!tag || tag === 'BODY') return null;
    if (tag === 'BUTTON') {
        return target.id;
    } else {
        const elem = target.parentElement;
        if (!elem) return null;
        else return getBtnElementId(elem);
    }
}
